import React from 'react';
import Select from 'react-select'
import { ajaxGet } from '../ajax'

class MasterSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      master: props.master
    }
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.loadPlayers = input => {
      if (!input || input.length < 3) return Promise.resolve({options: []})
      return ajaxGet(`/admins/facility_clients.json?query=${input}&all=true`)
      .then(response => response.json())
      .then(json => {
        return {
          options: json.clients.map(user => ({ value: user.id, label: user.name, phone: user.phone }))
        }
      })
    }
  }

  handleSelectChange(value) {
    this.setState({master: value})
    this.props.onChange(value)
  }

  render() {
    return (
      <Select.Async
        loadOptions={this.loadPlayers}
        onChange={this.handleSelectChange}
        placeholder='Select a client'
        autoBlur
        filterOption={() => true}
        value={this.state.master}
        searchPromptText='Please enter 3 or more characters'
      />
    )
  }
}

export default MasterSelector
